import { BlockWrapper, defineBlock } from "@smartfire/js-block-engine";
import { ReactComponent as ArrowRight } from "../assets/icons/arrow-right.svg";
import style from "./block.module.scss";

function Block() {
  function handleClick() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  return (
    <BlockWrapper.Div onClick={handleClick} className={style.block}>
      <ArrowRight />
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Scroll Top",
  },
});
